export const Container = ({ children }) => {
    return (
        <div className="w-full px-4 mt-8 h-full overflow-x-auto">
            {children}
        </div>
    );
};
